/**
 * Nada de dado pessoal sai pro Sentry (LGPD): CPF, e-mail, telefone e numero de cartao sao mascarados em mensagens,
 * logs, URLs e detalhes; senha, token e cookie saem como "[filtrado]". O cartao nem passa pelos nossos servidores (e
 * tokenizado na Pagar.me): a mascara e so rede de seguranca. Ids de rastreio e a pilha do erro nao sao tocados.
 *
 * Segredo tambem anda dentro de URL (revisao da sessao do legado, 15/09): o token do link de criar senha
 * (`?token=`), a sessao da compra (`/v1/tentativas/<sessao>`, `?s=`) e os links `/checkout/<token>` e `/pagar/<token>`.
 * Parametro sensivel na query e trecho de caminho opaco (20 ou mais letras, numeros, `_` ou `-`) viram "[filtrado]".
 * O codigo do pedido (`mtc_...`) e o id do banco (cuid) nao sao segredo e ficam, pra busca.
 */
const CARTAO = /\b(?:\d{13,19}|\d{4}([ -])\d{4}\1\d{4}\1\d{1,7})\b/g;
const CPF = /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g;
const EMAIL = /\b([A-Za-z0-9._%+-])[A-Za-z0-9._%+-]*@([A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,})\b/g;
const TELEFONE = /(?:\+?55[\s-]?)?\(?\b\d{2}\)?[\s-]?9?\d{4}[\s-]?\d{4}\b/g;
const PARAMETRO_SENSIVEL = /([?&](?:token|access_token|refresh_token|code|codigo|sessao|s|t)=)[^&#\s"']+/gi;
// Fica: o codigo do pedido (`mtc_...`) e o id do banco (cuid, `c` + 24 minusculas ou numeros), que nao sao segredo e
// acham o registro. Nenhum segredo nosso tem 25 caracteres (checkout 20, cobranca 24, sessao 32, backend 43): mudar o
// tamanho de um token pede rever esta linha.
const CAMINHO_OPACO = /\/(?!mtc_)(?!c[a-z0-9]{24}(?=[/?#\s"']|$))[A-Za-z0-9_-]{20,}(?=[/?#\s"']|$)/g;
const JWT = /\beyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/g;
const CHAVE_SENSIVEL = /senha|password|passwd|secret|segredo|token|authorization|cookie|cvv|card_?number|numero_?do_?cartao/i;
/** Campos que sao ids ou metadados do proprio Sentry: mascarar quebraria o rastreio. */
const SEM_MASCARA = new Set(["event_id", "trace_id", "span_id", "parent_span_id", "release", "environment", "dist", "platform", "level", "type", "op", "origin", "status", "sdk", "timestamp", "start_timestamp", "codigo", "reqId", "stacktrace", "modules", "debug_meta"]);
export function mascararTexto(texto) {
    return texto
        .replace(JWT, "[filtrado]")
        .replace(PARAMETRO_SENSIVEL, "$1[filtrado]")
        .replace(CAMINHO_OPACO, "/[filtrado]")
        .replace(CARTAO, "[cartao]")
        .replace(CPF, (m) => `***.***.***-${m.slice(-2)}`)
        .replace(EMAIL, "$1***@$2")
        .replace(TELEFONE, "[telefone]");
}
/** Mascara tudo que for texto, em qualquer profundidade (ate 8 niveis), sem mudar a forma do objeto. */
export function mascararValor(valor, profundidade = 0) {
    if (typeof valor === "string")
        return mascararTexto(valor);
    if (!valor || typeof valor !== "object" || profundidade > 8)
        return valor;
    if (Array.isArray(valor))
        return valor.map((v) => mascararValor(v, profundidade + 1));
    const saida = {};
    for (const [chave, v] of Object.entries(valor)) {
        if (SEM_MASCARA.has(chave))
            saida[chave] = v;
        else if (CHAVE_SENSIVEL.test(chave) && v !== null && v !== undefined && v !== "")
            saida[chave] = "[filtrado]";
        else
            saida[chave] = mascararValor(v, profundidade + 1);
    }
    return saida;
}
//# sourceMappingURL=mascarar.js.map